import axios from "axios";

function apiBase() {
  return process.env.REACT_APP_BACKEND_BASEURL;
}

function messageFrom(error, fallback) {
  return error?.response?.data?.message || error?.message || fallback;
}

export async function listDailyReports(getAuthConfig, projectCode) {
  const config = await getAuthConfig();
  try {
    const response = await axios.get(`${apiBase()}/api/daily-reports`, {
      ...config,
      params: { projectCode },
    });
    return Array.isArray(response.data?.data) ? response.data.data : [];
  } catch (error) {
    throw new Error(messageFrom(error, "Couldn't load saved reports"));
  }
}

export async function getDailyReport(getAuthConfig, id) {
  const config = await getAuthConfig();
  try {
    const response = await axios.get(`${apiBase()}/api/daily-reports/${encodeURIComponent(id)}`, config);
    return response.data?.data;
  } catch (error) {
    throw new Error(messageFrom(error, "Couldn't open that report"));
  }
}

export async function createDailyReport(getAuthConfig, payload) {
  const config = await getAuthConfig();
  try {
    const response = await axios.post(`${apiBase()}/api/daily-reports`, payload, config);
    return response.data?.data;
  } catch (error) {
    throw new Error(messageFrom(error, "Couldn't save the report"));
  }
}

export async function updateDailyReport(getAuthConfig, id, payload) {
  const config = await getAuthConfig();
  try {
    const response = await axios.patch(`${apiBase()}/api/daily-reports/${encodeURIComponent(id)}`, payload, config);
    return response.data?.data;
  } catch (error) {
    throw new Error(messageFrom(error, "Couldn't save the report"));
  }
}

export async function deleteDailyReport(getAuthConfig, id) {
  const config = await getAuthConfig();
  try {
    await axios.delete(`${apiBase()}/api/daily-reports/${encodeURIComponent(id)}`, config);
  } catch (error) {
    throw new Error(messageFrom(error, "Couldn't delete the report"));
  }
}
